import { render, staticRenderFns } from "./ClientMenus.vue?vue&type=template&id=9cd97a64&"
import script from "./ClientMenus.vue?vue&type=script&lang=js&"
export * from "./ClientMenus.vue?vue&type=script&lang=js&"
import style0 from "./ClientMenus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports